// extracted by mini-css-extract-plugin
export default {"form":"Gs6lM0k_LEkIZsLIxL5t","content":"TjuZ4yj5I0q2SDpF7Ch9"};